import React, { useState } from 'react'
import Modal from '../../components/common/Modal';

const initialLeaveForm = {
    leaveType: "",
    department: "",
    staff: "",
    fromDate: "",
    toDate: "",
    leaveStatus: "",
    reason: "",
    photo: null,
};
const StaffsLeaveRequests = () => {
    const [filters, setFilters] = useState({
        department: "",
        staff: "",
        leaveStatus: "",
        paymentStatus: "",
        fromDate: "",
        toDate: "",
    });


    const [search, setSearch] = useState("");
    const [showLeaveModal, setShowLeaveModal] = useState(false);

    const [leaveForm, setLeaveForm] = useState(initialLeaveForm);

    // ADD THIS
    const [editId, setEditId] = useState(null);

    const [leaveData, setLeaveData] = useState([
        {
            id: 1,
            staffName: "G. Anitha",
            department: "Teaching",
            phoneNumber: "8639886221",
            leaveType: "Casual Leave",
            fromDate: "2025-07-21",
            toDate: "2025-07-22",
            reason: "Fever",
            status: "Waiting",
            addedDate: "2025-07-03 11:32:37",
            paymentStatus: "Waiting",
        },
        {
            id: 2,
            staffName: "G. Anitha",
            department: "Teaching",
            phoneNumber: "8639886221",
            leaveType: "Casual Leave",
            fromDate: "2025-07-09",
            toDate: "2025-07-10",
            reason: "Test",
            status: "Waiting",
            addedDate: "2025-07-02 13:49:17",
            paymentStatus: "Waiting",
        },
    ]);

    const filteredData = leaveData.filter((item) =>
        Object.values(item)
            .join(" ")
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    const handleEdit = (row) => {
        setEditId(row.id);

        setLeaveForm({
            leaveType: row.leaveType,
            department: row.department,
            staff: row.staffName,
            fromDate: row.fromDate,
            toDate: row.toDate,
            leaveStatus: row.status,
            reason: row.reason,
            photo: null,
        });

        setShowLeaveModal(true);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure want to delete this leave request?")) {
            setLeaveData((prev) =>
                prev.filter((item) => item.id !== id)
            );
        }
    };

    const handleChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value,
        });
    };

    const handleSearch = () => {
        console.log("Search Data:", filters);
    };
    const handleReset = () => {
        setFilters({
            department: "",
            staff: "",
            leaveStatus: "",
            paymentStatus: "",
            fromDate: "",
            toDate: "",
        });
    };

    const handleLeaveChange = (e) => {
        const { name, value, files } = e.target;

        setLeaveForm({
            ...leaveForm,
            [name]: files ? files[0] : value,
        });
    };

    const handleLeaveSubmit = (e) => {
        e.preventDefault();

        if (editId) {
            // UPDATE RECORD
            setLeaveData((prev) =>
                prev.map((item) =>
                    item.id === editId
                        ? {
                            ...item,
                            staffName: leaveForm.staff,
                            department: leaveForm.department,
                            leaveType: leaveForm.leaveType,
                            fromDate: leaveForm.fromDate,
                            toDate: leaveForm.toDate,
                            reason: leaveForm.reason,
                            status: leaveForm.leaveStatus,
                        }
                        : item
                )
            );
        } else {
            // ADD NEW RECORD
            const newLeave = {
                id: Date.now(),
                staffName: leaveForm.staff,
                department: leaveForm.department,
                phoneNumber: "9999999999",
                leaveType: leaveForm.leaveType,
                fromDate: leaveForm.fromDate,
                toDate: leaveForm.toDate,
                reason: leaveForm.reason,
                status: leaveForm.leaveStatus,
                paymentStatus: "Waiting",
                addedDate: new Date().toLocaleString(),
            };

            setLeaveData((prev) => [newLeave, ...prev]);
        }

        setLeaveForm(initialLeaveForm);
        setEditId(null);
        setShowLeaveModal(false);
    };

    return (
        <>
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">
                        Staffs Leave Requests
                    </h4>

                    <button className="btn-add" onClick={() => {
                        setEditId(null);
                        setLeaveForm(initialLeaveForm);
                        setShowLeaveModal(true);
                    }}>
                        <i className="bi bi-plus-lg me-1 fw-bold"></i>
                        Add Leave
                    </button>
                </div>
                <div className="card-header tab-pane fade show active" id="home">
                    <div className="row g-3">

                        {/* Department */}
                        <div className="col-md-2 col-sm-4">
                            <label className="form-label">
                                Department
                            </label>

                            <select
                                className="form-select"
                                name="department"
                                value={filters.department}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Please select department
                                </option>
                                <option value="Administration">
                                    Administration
                                </option>
                                <option value="Accounts">
                                    Accounts
                                </option>
                                <option value="Teaching">
                                    Teaching
                                </option>
                                <option value="Transport">
                                    Transport
                                </option>
                            </select>
                        </div>

                        {/* Staff */}
                        <div className="col-md-2 col-sm-4">
                            <label className="form-label">
                                Select Staff
                            </label>

                            <select
                                className="form-select"
                                name="staff"
                                value={filters.staff}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Please select staff
                                </option>
                                <option value="John">
                                    John
                                </option>
                                <option value="Ramesh">
                                    Ramesh
                                </option>
                                <option value="Suresh">
                                    Suresh
                                </option>
                            </select>
                        </div>

                        {/* Leave Status */}
                        <div className="col-md-2 col-sm-4">
                            <label className="form-label">
                                Leave Status
                            </label>

                            <select
                                className="form-select"
                                name="leaveStatus"
                                value={filters.leaveStatus}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Please Select
                                </option>
                                <option value="Pending">
                                    Pending
                                </option>
                                <option value="Approved">
                                    Approved
                                </option>
                                <option value="Rejected">
                                    Rejected
                                </option>
                            </select>
                        </div>

                        {/* Leave Payment Status */}
                        <div className="col-md-2 col-sm-4">
                            <label className="form-label">
                                Leave Payment Status
                            </label>

                            <select
                                className="form-select"
                                name="paymentStatus"
                                value={filters.paymentStatus}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Please Select
                                </option>
                                <option value="Paid">
                                    Paid
                                </option>
                                <option value="Unpaid">
                                    Unpaid
                                </option>
                            </select>
                        </div>

                        {/* From Date */}
                        <div className="col-md-2 col-sm-4">
                            <label className="form-label">
                                From Date
                            </label>

                            <input
                                type="date"
                                className="form-control"
                                name="fromDate"
                                value={filters.fromDate}
                                onChange={handleChange}
                            />
                        </div>

                        {/* To Date */}
                        <div className="col-md-2 col-sm-4">
                            <label className="form-label">
                                To Date
                            </label>

                            <input
                                type="date"
                                className="form-control"
                                name="toDate"
                                value={filters.toDate}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Buttons */}
                        <div className="col-12 text-center">
                            <div className="d-flex justify-content-center gap-2 mt-2">
                                <button
                                    className="btn btn-info text-white"
                                    onClick={handleSearch}
                                >
                                    Search
                                </button>

                                <button
                                    className="btn btn-secondary"
                                    onClick={handleReset}
                                >
                                    Reset Search
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

                {/* staff table start */}
                <div className="card shadow-sm">
                     <div className="card-body">                        
                        <div className="table-responsive">
                            <table className="table table-bordered align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th>Staff Name</th>
                                        <th>Department</th>
                                        <th>Phone Number</th>
                                        <th>Leave Type</th>
                                        <th>From Date</th>
                                        <th>To Date</th>
                                        <th>Reason</th>
                                        <th>Status</th>
                                        <th>Added Date</th>
                                        <th>Paid/Unpaid</th>
                                        <th width="120">Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((row) => (
                                            <tr key={row.id}>
                                                <td>{row.staffName}</td>
                                                <td>{row.department}</td>
                                                <td>{row.phoneNumber}</td>
                                                <td>{row.leaveType}</td>
                                                <td>{row.fromDate}</td>
                                                <td>{row.toDate}</td>
                                                <td>{row.reason}</td>

                                                <td>
                                                    <span className="badge bg-warning text-dark">
                                                        {row.status}
                                                    </span>
                                                </td>

                                                <td>{row.addedDate}</td>

                                                <td>
                                                    <span className="badge bg-secondary">
                                                        {row.paymentStatus}
                                                    </span>
                                                </td>

                                                <td>
                                                    <button
                                                        className="btn btn-success btn-sm me-2"
                                                        onClick={() => handleEdit(row)}
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </button>

                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() =>
                                                            handleDelete(row.id)
                                                        }
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="11"
                                                className="text-center"
                                            >
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Footer */}
                        <div className="d-flex justify-content-between align-items-center mt-2">
                            <div className="d-flex gap-3">
                                <button className="btn btn-info text-white">
                                    Export to Excel
                                </button>
                                <span className=" gap-2">
                                    <select
                                        className="form-select"
                                        style={{ width: "80px" }}
                                    >
                                        <option>10</option>
                                        <option>25</option>
                                        <option>50</option>
                                        <option>100</option>
                                    </select>
                                </span>
                            </div>

                            <div>
                                Showing 1 to {filteredData.length} of{" "}
                                {filteredData.length} entries
                            </div>


                            <div>
                                <button className="btn btn-light border me-1">
                                    <i className="bi bi-chevron-double-left"></i>
                                </button>

                                <button className="btn btn-info text-white me-1">
                                    1
                                </button>

                                <button className="btn btn-light border">
                                    <i className="bi bi-chevron-double-right"></i>
                                </button>
                            </div>
                        </div>

                        {/* Export */}

                    </div>
                </div>
                {/* staff table end */}
                <Modal
                    show={showLeaveModal}
                    onClose={() => setShowLeaveModal(false)}
                    title={editId ? "Edit Leave" : "Add Leave"}
                    size="lg"
                >
                    <form onSubmit={handleLeaveSubmit}>
                        <div className="row">

                            {/* Leave Type */}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Leave Type</label>

                                <select
                                    className="form-select"
                                    name="leaveType"
                                    value={leaveForm.leaveType}
                                    onChange={handleLeaveChange}
                                    required
                                >
                                    <option value="">Please Select</option>
                                    <option>Casual Leave</option>
                                    <option>Sick Leave</option>
                                    <option>Emergency Leave</option>
                                    <option>Maternity Leave</option>
                                    <option>Vacation Leave</option>
                                </select>
                            </div>

                            {/* Department */}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Department</label>

                                <select
                                    className="form-select"
                                    name="department"
                                    value={leaveForm.department}
                                    onChange={handleLeaveChange}
                                    required
                                >
                                    <option value="">Select Department</option>
                                    <option>Administration</option>
                                    <option>Accounts</option>
                                    <option>Teaching</option>
                                    <option>Transport</option>
                                    <option>Library</option>
                                </select>
                            </div>

                            {/* Staff */}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Select Staff</label>

                                <select
                                    className="form-select"
                                    name="staff"
                                    value={leaveForm.staff}
                                    onChange={handleLeaveChange}
                                    required
                                >
                                    <option value="">Please select staff</option>
                                    <option>Anitha</option>
                                    <option>Sandya Rani</option>
                                    <option>Chandhan Sridhar</option>
                                    <option>Shravya</option>
                                </select>
                            </div>

                            {/* From Date */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">From Date</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="fromDate"
                                    value={leaveForm.fromDate}
                                    onChange={handleLeaveChange}
                                    required
                                />
                            </div>

                            {/* To Date */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">To Date</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="toDate"
                                    value={leaveForm.toDate}
                                    onChange={handleLeaveChange}
                                    required
                                />
                            </div>

                            {/* Leave Status */}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Leave Status</label>

                                <select
                                    className="form-select"
                                    name="leaveStatus"
                                    value={leaveForm.leaveStatus}
                                    onChange={handleLeaveChange}
                                    required
                                >
                                    <option value="">Please Select</option>
                                    <option>Pending</option>
                                    <option>Approved</option>
                                    <option>Rejected</option>
                                </select>
                            </div>

                            {/* Reason */}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Reason</label>

                                <textarea
                                    rows="4"
                                    className="form-control"
                                    name="reason"
                                    value={leaveForm.reason}
                                    onChange={handleLeaveChange}
                                ></textarea>
                            </div>

                            {/* Upload */}
                            <div className="col-md-12 mb-4">
                                <label className="form-label">Photo Upload</label>

                                <input
                                    type="file"
                                    className="form-control"
                                    name="photo"
                                    onChange={handleLeaveChange}
                                />
                            </div>

                            {/* Buttons */}
                            <div className="col-md-12">
                                <button
                                    type="submit"
                                    className="btn btn-info text-white me-2 px-4"
                                >
                                    {editId ? "Update Leave" : "Add Leave"}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-light border px-4"
                                    onClick={() => setShowLeaveModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </form>
                </Modal>
            </div>
        </>
    )
}

export default StaffsLeaveRequests